var _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrowser = function SvgBrowser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    fill: "#C8C8C8",
    fillRule: "evenodd",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.005c0 .55.444.995.991.995H21.01a.99.99 0 0 0 .991-.995V2.995A.993.993 0 0 0 21.009 2H2.99A.99.99 0 0 0 2 2.995zM2.991 1H21.01C22.109 1 23 1.893 23 2.995v14.01C23 18.107 22.11 19 21.009 19H2.99C1.891 19 1 18.107 1 17.005V2.995C1 1.893 1.89 1 2.991 1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 3.5,
    r: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 3.5,
    r: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6h.5V5H1v1h.5z"
  })));
};
export default SvgBrowser;